import Countdown from '../components/Countdown';
import RSVP from '../components/RSVP';
import './Landing.scss';

const Wedding = () => {
  const weddingDate = '2026-05-29';

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) element.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="landing">
      <div className="landing-background">
        <div className="floating-hearts">
          {[...Array(20)].map((_, i) => (
            <div key={i} className="heart" style={{ left: `${Math.random() * 100}%`, animationDelay: `${Math.random() * 5}s` }}>
              ♥
            </div>
          ))}
        </div>
      </div>

      <div className="landing-content">
        <div className="hero-section">
          <div className="names-container">
            <h1 className="name name-left fade-in-left">Rajesh Kanna</h1>
            <div className="heart-divider">
              <span className="heart-icon">♥</span>
            </div>
            <h1 className="name name-right fade-in-right">Indira</h1>
          </div>

          <p className="tagline fade-in-up">We're getting married!</p>

          <div className="date-info fade-in-up">
            <p className="save-date">Save the Date</p>
            <p className="wedding-date">
              {new Date(weddingDate).toLocaleDateString('en-US', {
                year: 'numeric', month: 'long', day: 'numeric'
              })}
            </p>
          </div>

          <Countdown targetDate={weddingDate} />

          <div className="cta-buttons fade-in-up">
            <button className="btn btn-secondary" onClick={() => scrollToSection('rsvp')}>RSVP</button>
          </div>
        </div>
      </div>

      <RSVP />
    </div>
  );
};

export default Wedding;
